import { CLIENT_ID, CLIENT_SECRET, ROOT_URL } from "../config";
import { store } from "../store";
import { decodeString } from "./security";

export const fetchApi = ({ path = "", method = "GET", body = null }) => {
  let state = store.getState();
  let token = state.user.loginData.access_token;
  let options = {
    method: method,
    headers: {
      "Content-Type": "application/json",
    },
  };
  token
    ? (options.headers["Authorization"] = `bearer ${decodeString(token)}`)
    : null;
  body ? (options["body"] = JSON.stringify(body)) : body;

  return fetch(`${ROOT_URL}${path}`, options)
    .then((res) => {
      if (res.status >= 500 && res.status < 600) {
        return {
          status: 500,
          message: { error: "Ooops!,something went wrong" },
        };
      }
      return res.json();
    })
    .then((res) => {
      if (res.message && res.status) {
        const {
          status,
          message: { error = "" },
        } = res;
        if (status >= 400 && status < 500) {
          return {
            error: "client error",
            error_description: JSON.stringify(error),
          };
        } else if (status >= 500 && status < 600) {
          return {
            error: "server error",
            error_description: JSON.stringify(error),
          };
        }
      } else {
        return res;
      }
    })
    .catch((e) => {
      console.log(e);
      return Promise.resolve({
        error: "network error",
        error_description: "Internet not available",
      });
    });
};

export const fetchToken = ({ username, password }) => {
  return fetchApi({
    path: "/token",
    method: "POST",
    body: {
      username: username,
      password: password,
      client_id: CLIENT_ID,
      client_secret: CLIENT_SECRET,
      grant_type: "password",
    },
  });
};
